module.exports = __webpack_public_path__ + "img/valued tools of the trade.f25b7f38.png";